import { useState, useEffect, useMemo } from "react";
import Image from "next/image";

import MessageIcon from "../../public/assets/goat-spins-message-instant-withdrawals.svg";
import {
  getPlayerMessages,
  getMessageDetails,
  updateMessageStatus,
} from "@/src/services/message";

const isUnreadMessage = (message) =>
  ["unread", "received"].includes(
    String(message?.status_description || "").toLowerCase(),
  );

export default function MessageCenter({ user }) {
  const [showMessagesPopup, setShowMessagesPopup] = useState(false);
  const [messages, setMessages] = useState([]);
  const [selectedMessageId, setSelectedMessageId] = useState(null);
  const [selectedMessages, setSelectedMessages] = useState([]);

  const playerId = user?.username;

  useEffect(() => {
    if (!playerId) return;
    const fetchAllMessages = async () => {
      try {
        const list = await getPlayerMessages(playerId);
        setMessages(Array.isArray(list) ? list : []);
      } catch {}
    };

    fetchAllMessages();
  }, [playerId]);

  useEffect(() => {
    if (!playerId || !showMessagesPopup) return;
    const fetchAllMessages = async () => {
      try {
        const list = await getPlayerMessages(playerId);
        setMessages(Array.isArray(list) ? list : []);
      } catch {}
    };
    fetchAllMessages();
  }, [playerId, showMessagesPopup]);

  // Sakriva main menu kada je otvoren MessagePopup
  useEffect(() => {
    const el = document.getElementById("MainMenu");
    if (el) el.style.display = showMessagesPopup ? "none" : "block";
  }, [showMessagesPopup]);

  // ----------- HANDLERS ------------
  const handleCheckboxChange = (messageid) => {
    setSelectedMessages((prev) =>
      prev.includes(messageid)
        ? prev.filter((id) => id !== messageid)
        : [...prev, messageid],
    );
  };

  const handleOpenMessage = async (message) => {
    const messageId = message?.messageid;
    if (messageId === null || messageId === undefined) return;

    setSelectedMessageId(messageId);

    try {
      const details = await getMessageDetails(messageId);
      setMessages((curr) =>
        curr.map((m) =>
          m.messageid === messageId
            ? {
                ...m,
                body: details?.body ?? m.body,
              }
            : m,
        ),
      );

      if (isUnreadMessage(message)) {
        await updateMessageStatus({
          messageId,
          playerId,
          skinId: 1,
          status: "read",
        });
        setMessages((curr) =>
          curr.map((m) =>
            m.messageid === messageId
              ? {
                  ...m,
                  status_description: "Read",
                }
              : m,
          ),
        );
      }
    } catch {}
  };

  const handleCloseMessages = () => {
    setShowMessagesPopup(false);
    setSelectedMessageId(null);
  };

  const handleDeleteSelected = async () => {
    if (selectedMessages.length === 0) return;
    try {
      await Promise.all(
        selectedMessages.map((messageId) =>
          updateMessageStatus({
            messageId,
            playerId,
            skinId: 1,
            status: "deleted",
          }),
        ),
      );
      setMessages((current) =>
        current.filter((m) => !selectedMessages.includes(m.messageid)),
      );
      if (selectedMessageId && selectedMessages.includes(selectedMessageId)) {
        setSelectedMessageId(null);
      }
      setSelectedMessages([]);
    } catch {}
  };

  // ----------- READ/UNREAD COUNT ------------
  const unreadCount = useMemo(
    () => messages.filter((m) => isUnreadMessage(m)).length,
    [messages],
  );

  const selectedMessage = useMemo(
    () =>
      messages.find((m) => String(m.messageid) === String(selectedMessageId)),
    [messages, selectedMessageId],
  );
  return (
    <>
      <div
        id="BoxMessages"
        style={{ position: "relative" }}
        onClick={() => setShowMessagesPopup((prev) => !prev)}
      >
        <Image
          width={50}
          height={50}
          src={MessageIcon}
          alt="message-icon"
          className="msgg"
        />
        {unreadCount > 0 && <div className="UnreadBadge">{unreadCount}</div>}
      </div>

      {showMessagesPopup && (
        <div className="MessagePopupBackdrop">
          <div className="MessagePopupContainer">
            <button
              className="CloseBtn"
              onClick={handleCloseMessages}
            >
              X
            </button>

            {selectedMessageId === null ? (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <h2 className="msg-h2">Inbox</h2>
                  <div className="pppr" onClick={handleDeleteSelected}>
                    &#128465;
                  </div>
                </div>

                {messages.length === 0 ? (
                  <p>No messages found.</p>
                ) : (
                  messages.map((item) => {
                    const isUnread = isUnreadMessage(item);
                    return (
                      <div
                        key={item.messageid}
                        className="MessageTitleBox"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedMessages.includes(item.messageid)}
                            onChange={() =>
                              handleCheckboxChange(item.messageid)
                            }
                          />
                          <h3
                            className={isUnread ? "unreadMessage" : ""}
                            style={{
                              cursor: "pointer",
                              marginLeft: 8,
                              marginBottom: 0,
                              fontWeight: isUnread ? "bold" : "normal",
                            }}
                            onClick={() => handleOpenMessage(item)}
                          >
                            {item.title}
                          </h3>
                        </div>
                        {isUnread && <div className="GreenDot" />}
                      </div>
                    );
                  })
                )}
              </>
            ) : (
              <>
                <button
                  className="BackBtn"
                  onClick={() => setSelectedMessageId(null)}
                >
                  ◀
                </button>
                <div className="MessageContentContainer">
                  <h3>{selectedMessage?.title}</h3>
                  <div
                    className="MessageContent"
                    dangerouslySetInnerHTML={{
                      __html: selectedMessage?.body,
                    }}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
